import styled from 'styled-components';

export const IconWrapper = styled.div`
  width: 36px;
  height: 36px;
  background: #f5f5f5;

  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;

    path,
    rect {
      fill: ${props => props.theme.colors.primary.main};
    }
  }

  &:hover {
    background: #f1f1f1;
  }
`;
